<template>
  <div class="content">
      <el-form :model="withdrawalForm" ref="withdrawalForm" :inline="true">
        <el-form-item prop="userId">
            <el-cascader
            placeholder="公司名"
            ref="myCascader"
            :options="agentList"
            :props="{ value : 'userId' ,checkStrictly: true,emitPath:false }"
            :show-all-levels="false"
            clearable
            style="width:210px;margin-right:30px;"
            v-model="withdrawalForm.userId"
            @change="search"
            filterable
          >
            <template slot-scope="{ node, data }">
              <span>[{{ data.username }}]{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
        <el-form-item prop="orderStatus">
          <el-select v-model="withdrawalForm.orderStatus" filterable placeholder="审核状态" @change="search" clearable>
            <el-option v-for="item in state" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="searchTime">
          <el-date-picker 
            style="margin-right:30px"
            value-format="yyyy-MM-dd"
            v-model="withdrawalForm.searchTime"
            @change="search"
            type="daterange"
            range-separator="-"
            start-placeholder="申请开始日期"
            end-placeholder="申请结束日期">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form>
      <div class="table" style="margin-top: 10px">
        <el-table :data="tableData" border v-loading="loading">
          <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
          <el-table-column prop="companyName" label="公司名称" align="center" width="200px"></el-table-column>
          <el-table-column prop="orderId" label="订单号" align="center" width="200px"></el-table-column>
          <el-table-column prop="orderMoney" label="提现金额" align="center"></el-table-column>
          <el-table-column prop="actualAmount" label="实际到账金额" align="center" width="160px"></el-table-column>
          <el-table-column prop="serviceCharge" label="手续费" align="center" width="80px"></el-table-column>
          <el-table-column prop="taxMoney" label="税金" align="center" width="80px"></el-table-column>
          <el-table-column prop="orderStatus" label="状态" align="center">
            <template slot-scope="scope">
              <el-tag type="warning" v-if="scope.row.orderStatus=='1'">{{ inventoryOrderStatus(scope.row.orderStatus) }}</el-tag>
              <el-tag type="primary" v-else-if="scope.row.orderStatus=='2'">{{ inventoryOrderStatus(scope.row.orderStatus) }}</el-tag>
              <el-tag type="success" v-else-if="scope.row.orderStatus=='4'">{{ inventoryOrderStatus(scope.row.orderStatus) }}</el-tag>
              <el-tag type="danger" v-else>{{ inventoryOrderStatus(scope.row.orderStatus) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="payMode" label="提现方式" align="center" >
              <template slot-scope="scope">
                {{inventoryPayMode(scope.row.payMode)}}
              </template>
          </el-table-column>
          <el-table-column prop="orderTime" label="申请时间" align="center" width="160px"></el-table-column>
          <el-table-column prop="dateRange" label="结算时间段" align="center" width="200px"></el-table-column>
          <el-table-column prop="auditTime" label="审核时间" align="center" width="160px"></el-table-column>
          <el-table-column prop="withdrawalRemark" label="申请备注" align="center" width="260px"></el-table-column>
          <el-table-column prop="errMsg" label="失败原因" align="center" width="160px"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" min-width="120"> 
						<template slot-scope="scope">
							<el-button v-if="scope.row.orderStatus=='1'" size="mini" type="primary" plain icon="el-icon-s-check" @click="authClick(scope.row.id)" >审核</el-button>
              <el-button v-else size="mini"  type="primary" plain icon="el-icon-view"  @click="authClick(scope.row.id)" >查看</el-button>
						</template>
					</el-table-column>
        </el-table>
      </div>
      <div class="block" style="margin-top: 30px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
  </div>
</template>
<script>
import { agentTreeList } from "@/api/api.js"; //代理商
import { pageUserWithdrawal } from "@/api/api.js"; //用户提现信息列表
export default {
  name:'audit',
  data() {
    return {
      loading:false,
      withdrawalForm:{
        userId:undefined,
        orderStatus:undefined,
        searchTime:[]
      },
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
      state: [
        {
          key: "1",
          value: "待审核"
        },
        {
          key: "2",
          value: "审核通过"
        },
        {
          key: "3",
          value: "结算中"
        },
        {
          key: "4",
          value: "结算成功"
        },
        {
          key: "5",
          value: "结算失败"
        },
        {
          key: "6",
          value: "拒绝"
        }
      ],
      agentList:[]
    };
  },
  methods: {
    initData() {
      let params = {
        model:{
          ...this.addDateRange(this.withdrawalForm, this.withdrawalForm.searchTime)
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      pageUserWithdrawal(params).then(res=>{
          this.loading = false
          if(res.data.code==200){
            this.tableData = res.data.data.records;
            this.total = res.data.data.total;
          }else{
            this.$message.error(res.data.message);
          }
      })
    },
    inventoryPayMode(status) {
      let obj = {
        1: "微信",
        2: "支付宝",
        3: "余额",
        4: "银行卡对公账户"
      };
      return obj[status];
    },
    inventoryOrderStatus(status) {
      let obj = {
        1: "待审核",
        2: "审核通过",
        3: "结算中",
        4: "结算成功",
        5: "结算失败",
        6: "拒绝"
      };
      return obj[status];
    },
    // 搜索
    search(){
      this.initData()
    },
    // 获取初始化代理商列表
    agentTreeListMethod(){
      agentTreeList().then(res => {
        if (res.data.code == 200) {
          this.agentList = res.data.data;
        }
      });
    },
    // 用户充值记录的重置
    reset(){
      this.resetForm("withdrawalForm");
      this.initData();
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.initData()
    },
    handleCurrentChange(page) {
      this.page = page;
      this.initData()
    },
    authClick(id){
      this.$router.push(`/scale/withdrawDetail/`+id);
    }
  },
  mounted() {

  },
  created() {
    this.agentTreeListMethod();
    this.initData()
  }
};
</script>
<style scoped lang="less">
  
</style>


